module.exports = __webpack_public_path__ + "img/tools.bd297b78.svg";